"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const SportsConfig_1 = require("../../lib/sports/SportsConfig");
const moment_1 = tslib_1.__importDefault(require("moment"));
const getPeriodStartMins_1 = require("./getPeriodStartMins");
const getMaxPeriodMins_1 = require("./getMaxPeriodMins");
const formatClock_1 = require("./formatClock");
const camelcase_1 = tslib_1.__importDefault(require("camelcase"));
exports.getRunningClock = (sportName, clockInfo, periods, currentPeriodCode, config, skewMsAdjustment = 0) => {
    let clock = '';
    let injuryTimeClock = '';
    const utcMilliClockStart = moment_1.default
        .utc(clockInfo.clockChangeDate)
        .toDate()
        .getTime();
    const date = moment_1.default();
    const utcNow = date
        .subtract(skewMsAdjustment, 'milliseconds')
        .toDate()
        .getTime();
    let tillNextTick = 500;
    let secondsSinceStart;
    const msSinceClockStart = utcNow - utcMilliClockStart;
    const completedSecondsSinceClockStart = Math.floor(msSinceClockStart / 1000);
    tillNextTick = (completedSecondsSinceClockStart + 1) * 1000 - msSinceClockStart;
    if (SportsConfig_1.sportsConfig[camelcase_1.default(sportName)].clock.direction === 'up') {
        const startedMins = Math.floor(clockInfo.clockInMs / 60000);
        const startedSecs = (clockInfo.clockInMs - startedMins * 60000) / 1000;
        const startedTotalSecs = startedMins * 60 + startedSecs;
        const rawSeconds = startedTotalSecs + completedSecondsSinceClockStart;
        const periodOffsetMins = getPeriodStartMins_1.getPeriodStartMins(sportName, periods, currentPeriodCode, config);
        const maxPeriodSeconds = (periodOffsetMins + (getMaxPeriodMins_1.getMaxPeriodMins(sportName, periods, currentPeriodCode, config) || 0)) * 60;
        const [periodStartMins, periodStartSecs] = [periodOffsetMins, 0];
        secondsSinceStart = rawSeconds - (periodStartMins * 60 + periodStartSecs);
        const injurySeconds = rawSeconds - maxPeriodSeconds;
        const seconds = Math.min(rawSeconds, maxPeriodSeconds);
        clock = formatClock_1.formatClock(Math.round(seconds));
        injuryTimeClock = injurySeconds > -1 ? formatClock_1.formatClock(Math.round(injurySeconds)) : '';
    }
    else if (SportsConfig_1.sportsConfig[sportName].clock.direction === 'down') {
        const startedMins = Math.floor(clockInfo.clockInMs / 60000);
        const startedSecs = (clockInfo.clockInMs - startedMins * 60000) / 1000;
        const startedTotalSecs = startedMins * 60 + startedSecs;
        const rawRemainingSecs = startedTotalSecs - completedSecondsSinceClockStart;
        const remainingSecs = rawRemainingSecs;
        // @ts-ignore
        const periodStartMins = getPeriodStartMins_1.getPeriodStartMins(match, summary, config);
        let remainingMins = Math.floor(remainingSecs / 60);
        let remainingSecsSansMins = remainingSecs - remainingMins * 60;
        if (remainingMins === 0) {
            if (remainingSecsSansMins < 0) {
                remainingMins = remainingSecsSansMins = 0;
            }
        }
        else if (remainingMins < 0) {
            remainingMins = remainingSecsSansMins = 0;
        }
        clock = formatClock_1.formatClock(Math.round(remainingSecs));
        const [periodMaxMins, periodMaxSecs] = [periodStartMins, 0];
        secondsSinceStart = (periodMaxMins - remainingMins) * 60 - (periodMaxSecs - remainingSecsSansMins);
    }
    return { tillNextTick, clock, secondsSinceStart, injuryTimeClock };
};
//# sourceMappingURL=getRunningClock.js.map